import store from "@/store/store";
import {authError, logout} from "@/store/authSlice";

import {catchErrors} from '../util/functions'
import axios from "axios";

export const BASE_URL = `${process.env.REACT_APP_PANEL_API ?? '/backend'}`

const TOKEN_REFRESH_ENDPOINT = '/api/auth/token/refresh/';

export const axiosInstance = axios.create({
    baseURL: BASE_URL,
})


async function updateAccessToken(refresh) {
    // A direct call to axios is needed to bypass the error interceptor
    const response = await axios.post(TOKEN_REFRESH_ENDPOINT, {refresh}, {
        baseURL: BASE_URL,
    });

    const {access: newAccessToken} = response.data;

    localStorage.setItem('access', newAccessToken);
}

const requestInterceptor = (config) => {
    const token = localStorage.getItem('access')

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
}

const successInterceptor = (response) => response.data;

async function errorInterceptor(requestError) {
    const oldAccessToken = localStorage.getItem('access');
    const refreshToken = localStorage.getItem('refresh');


    const needToUpdateAccessToken = (
        requestError?.response?.status === 401
        && !requestError.config.retry
        && oldAccessToken
        && refreshToken
    );

    if (needToUpdateAccessToken) {
        requestError.config.retry = true;

        try {
            await updateAccessToken(refreshToken);

            // If the access token was successfully refreshed - try to make the original request again
            return axiosInstance(requestError.config);
        } catch (error) {
            // If an error occurs while updating the access token - logout
            if (error?.response?.status === 401) {
                console.log('errorInterceptor 401', error);
                store.dispatch(logout())
            }
        }
    }

    if (requestError?.response?.status === 403) {
        store.dispatch(catchErrors(requestError, authError))
    }

    return Promise.reject(requestError);
}

axiosInstance.interceptors.request.use(requestInterceptor);


axiosInstance.interceptors.response.use(successInterceptor, errorInterceptor)
